<template>
  <div v-if="userData.userData">
    <Layout>
      <p class="heading font-weight-regular primary--text text-center">
        {{ $t("qr_view.qr_text") }}
      </p>
      <v-row justify="center">
        <v-col cols="12" class="d-flex justify-center ma-10">
          <div :style="cssProps">
            <qr-code
              class="qr-code"
              :text="userData.userData.id"
              :size="qrSize"
              error-level="H"
              bg-color="#ffffff00"
              :color="'#0C0C0C'"
            ></qr-code>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="auto">
          <v-btn
            :dark="$store.getters.themeOnSecondary === 'dark'"
            :light="$store.getters.themeOnSecondary === 'light'"
            color="primary"
            class="px-13 py-9"
            x-large
            rounded
            outlined
            outlined-border-width="7"
            @click="goBack($router)"
          >
            {{ $t("qr_view.dismiss_text") }}
          </v-btn>
        </v-col>
      </v-row>
    </Layout>
  </div>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import { mapState } from "vuex";
import { RequestService } from "../services/request.service";
import { goBack } from "@/utils/commonMethods";

const requestService = new RequestService();
export default {
  data() {
    return {
      qrSize: 200,
    };
  },
  components: {
    Layout,
  },
  methods: {
    goBack,
  },
  computed: {
    ...mapState(["userData"]),
    cssProps() {
      return {
        backgroundImage:
          "url(" + require("@/assets/images/qr_background.png") + ")",
        width: `${this.qrSize + 70}px`,
        height: `${this.qrSize + 70}px`,
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };
    },
  },
  created() {
    if (!this.userData.userData) {
      const context = this;
      requestService.getUserData(context);
    }
  },
};
</script>
